import React, {Component} from "react";
import { observer, inject } from "mobx-react";
import autobind from 'autobind-decorator';
import MainTopView from "../../../views/main/top/MainTopView";

@inject('rootStore')
@autobind
@observer
class MainTopContainer extends Component {
    render() {
        const { rootStore,topText } = this.props;

        return (
            <MainTopView rootStore={rootStore} topText={topText} />
        );
    }
}

export default MainTopContainer;